// https://github.com/airbnb/react-dates#initialize
import 'react-dates/initialize';
// Import CSS first, so that custom module CSS gets precendence
import './index.scss';
import './utils/sentry';

import { Chart } from 'chart.js';
import React from 'react';
import ReactChartkick from 'react-chartkick';
import ReactDOM from 'react-dom';
import { ReactTableDefaults } from 'react-table';

import Root from './Root';
import store from './store';
import { filterSingleBy } from './utils/column-helpers';

Object.assign(ReactTableDefaults, {
  filterable: true,
  defaultPageSize: 20,
  pageSizeOptions: [10, 20, 50, 100],
  defaultFilterMethod: (filter, row) =>
    filterSingleBy(filter, String(row[filter.id])),
});

ReactChartkick.addAdapter(Chart);

ReactDOM.render(
  React.createElement(Root, { store }),
  document.getElementById('root'),
);
